import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as API } from '../../../axiosConfig';

const URL = '/roles';

const SLICE_NAME = 'userManagementRoles';
const LIST_USER_MANAGEMENT_ROLES = `${SLICE_NAME}/user-management/roles/list`;
const CREATE_USER_MANAGEMENT_ROLE = `${SLICE_NAME}/user-management/roles/create`;

export const getUserManagementRoleList = createAsyncThunk(
  LIST_USER_MANAGEMENT_ROLES,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.get(URL);

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createRole = createAsyncThunk(
  CREATE_USER_MANAGEMENT_ROLE,
  async (payload) => {
    const response = await API.post(URL, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const initialState = {
  roleList: [],
  roleListStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed',
};

const userManagementRolesSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserManagementRoleList.pending, (state) => {
        state.roleListStatus = 'loading';
      })
      .addCase(getUserManagementRoleList.rejected, (state) => {
        state.roleList = [];
        state.roleListStatus = 'failed';
      })
      .addCase(getUserManagementRoleList.fulfilled, (state, { payload }) => {
        state.roleList = payload;
        state.roleListStatus = 'succeeded';
      });
  },
});

export const userManagementRolesActions = userManagementRolesSlice.actions;

export const selectUserManagementRolesList = (state) =>
  state.userManagement.roles.roleList;

export const selectIsLoadingUserManagementRolesList = (state) =>
  state.userManagement.roles.roleListStatus === 'loading';

export default userManagementRolesSlice.reducer;
